// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AdshelClassic-module__container___VtZDR {
    position: relative;
    display: inline-block;
    height: 510px;
    width: auto;
    aspect-ratio: 244/500;
    filter: 
        drop-shadow(-8px 8px 4px rgba(0, 0, 0, 0.15)) 
        drop-shadow(-15px 15px 10px rgba(0, 0, 0, 0.12)) 
        drop-shadow(-2px 2px 2px rgba(0, 0, 0, 0.1));
    transition: all 0.3s ease;
}

.AdshelClassic-module__backgroundImage___uabyK {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.AdshelClassic-module__overlayImage___w2sFT,
.AdshelClassic-module__overlayVideo___ms_Wc {
    position: absolute;
    top: 37%;
    left: 50%;
    transform: translate(-50%, -45%);
    width: 83%;
    height: 73%;
    object-fit: cover;
}

@media (max-width: 768px) {
    .AdshelClassic-module__container___VtZDR {
        height: 400px;
        /* Slightly reduce shadow intensity on mobile */
        filter: 
            drop-shadow(-6px 6px 3px rgba(0, 0, 0, 0.15)) 
            drop-shadow(-12px 12px 8px rgba(0, 0, 0, 0.12)) 
            drop-shadow(-1px 1px 1px rgba(0, 0, 0, 0.1));
    }
}
`, "",{"version":3,"sources":["webpack://./app/components/ProofOfDeliveryLayout/Panels/AdshelClassic/AdshelClassic.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,aAAa;IACb,WAAW;IACX,qBAAqB;IACrB;;;oDAGgD;IAChD,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;;IAEI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,UAAU;IACV,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI;QACI,aAAa;QACb,+CAA+C;QAC/C;;;wDAGgD;IACpD;AACJ","sourcesContent":[".container {\n    position: relative;\n    display: inline-block;\n    height: 510px;\n    width: auto;\n    aspect-ratio: 244/500;\n    filter: \n        drop-shadow(-8px 8px 4px rgba(0, 0, 0, 0.15)) \n        drop-shadow(-15px 15px 10px rgba(0, 0, 0, 0.12)) \n        drop-shadow(-2px 2px 2px rgba(0, 0, 0, 0.1));\n    transition: all 0.3s ease;\n}\n\n.backgroundImage {\n    display: block;\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n}\n\n.overlayImage,\n.overlayVideo {\n    position: absolute;\n    top: 37%;\n    left: 50%;\n    transform: translate(-50%, -45%);\n    width: 83%;\n    height: 73%;\n    object-fit: cover;\n}\n\n@media (max-width: 768px) {\n    .container {\n        height: 400px;\n        /* Slightly reduce shadow intensity on mobile */\n        filter: \n            drop-shadow(-6px 6px 3px rgba(0, 0, 0, 0.15)) \n            drop-shadow(-12px 12px 8px rgba(0, 0, 0, 0.12)) \n            drop-shadow(-1px 1px 1px rgba(0, 0, 0, 0.1));\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AdshelClassic-module__container___VtZDR`,
	"backgroundImage": `AdshelClassic-module__backgroundImage___uabyK`,
	"overlayImage": `AdshelClassic-module__overlayImage___w2sFT`,
	"overlayVideo": `AdshelClassic-module__overlayVideo___ms_Wc`
};
export default ___CSS_LOADER_EXPORT___;
